import CameritoStar from "@/assets/camerito/camerito-star.svg?react";
import CommonStar from "@/assets/common/premium.svg?react";
import { getAppValue } from "@/utils/getAppValue";
import YearIcon from "@/assets/common/annual.svg?react";
import MonthIcon from "@/assets/common/monthly.svg?react";
import WeekIcon from "@/assets/common/weekly.svg?react";

const StarIcons = {
  camerito: CameritoStar,
  bibino: CommonStar,
  barkio: CommonStar
};
export const DurationIcons = {
  year: YearIcon,
  month: MonthIcon,
  week: WeekIcon
};
const comparisionButtonTexts = {
  camerito: "upgradeToPremium",
  barkio: "account.button.joinPremium",
  bibino: "account.button.joinPremium"
} as const;

export const StarIcon = getAppValue(StarIcons);
export const comparisionButtonText = getAppValue(comparisionButtonTexts);
